import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom'; //link
import './App.css';
import Home from './Home';
import Lista from './Lista';
import DanfeList from './DanfeList';
import DanfeListFilter from './DanfeListFilter';
import DanfeListForm from './DanfeListForm';
import Navbar from 'react-bootstrap/Navbar'
import logo from './logo.svg'; // with import




class App extends React.Component {
    
    
    render() {
        return (
            <div>
                              <Navbar className="navbar navbar-light bg-light">
  <Navbar.Brand><a href="/danfelistform"><img src={logo} width="200" height="70" alt="logo" className="d-inline-block align-top"  /></a></Navbar.Brand>
  <Navbar.Toggle />
  <Navbar.Collapse className="d-flex justify-content-end">
    <Navbar.Text>
      <h1 className="meu-app"><strong>Consulta DANFE's</strong></h1>
    </Navbar.Text>
  </Navbar.Collapse>
</Navbar>
            <BrowserRouter>
                <div className="App">
             {/* <Link to="/danfelistform">Consulta DANFE</Link>  */}

                    <Route path="/danfelistform" exact component={Home}></Route>
                    <Route path="/lista" component={Lista}></Route>
                    <Route path="/danfelist" component={DanfeList}></Route>
                    <Route path="/danfelistfilter" component={DanfeListFilter}></Route>
                    <Route path="/danfelistform" component={DanfeListForm}></Route>
                    
                </div>
                <div>
                
                </div>
            </BrowserRouter>
            </div>
        );
    }
}

export default App;